import http from '@/utils/http'

export default {
  precheck: data => http({ url: '/api/admin/v1/yeepayMerchant/precheck', data, tip: true }),
  companyStatus: data => http({ url: '/api/admin/v1/yeepayMerchant/companyStatus', data }),
  createDraft: data => http({ url: '/api/admin/v1/yeepayMerchant/createDraft', data, tip: true }),
  saveSupplement: data => http({ url: '/api/admin/v1/yeepayMerchant/saveSupplement', data, tip: true }),
  uploadLocalMaterial: data => http({ url: '/api/admin/v1/yeepayMerchant/uploadLocalMaterial', data }),
  uploadQual: data => http({ url: '/api/admin/v1/yeepayMerchant/uploadQual', data, tip: true }),
  submit: data => http({ url: '/api/admin/v1/yeepayMerchant/submit', data, tip: true }),
  query: data => http({ url: '/api/admin/v1/yeepayMerchant/query', data, tip: true }),
  list: data => http({ url: '/api/admin/v1/yeepayMerchant/list', data }),
  detail: data => http({ url: '/api/admin/v1/yeepayMerchant/detail', data }),
  supplementDetail: data => http({ url: '/api/admin/v1/yeepayMerchant/supplementDetail', data }),
  apiLogs: data => http({ url: '/api/admin/v1/yeepayMerchant/apiLogs', data }),
  productDetails: data => http({ url: '/api/admin/v1/yeepayMerchant/productDetails', data }),
  notifyLogs: data => http({ url: '/api/admin/v1/yeepayMerchant/notifyLogs', data }),
  rebuildPayload: data => http({ url: '/api/admin/v1/yeepayMerchant/rebuildPayload', data }),
}
